export enum DracoSkeletonAnimationValues {
  Pulsing = 'pulsing',
  Shimmer = 'shimmer'
};
export type DracoSkeletonAnimations = `${DracoSkeletonAnimationValues}`;

export enum DracoSkeletonSizeValues {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
};
export type DracoSkeletonSizes = `${DracoSkeletonSizeValues}`;

export enum DracoSkeletonShapeValues {
  Square = 'square',
  Circle = 'circle',
  Rounded = 'pill'
};
export type DracoSkeletonShapes = `${DracoSkeletonShapeValues}`;